import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";
import * as userData from "@/auth/localStorageUtils.js";

const search = (params) => {
  return axiosGet(appsettings.ocpbComplaintAPIUrl + "api/EditorDom/Search", params);
};

const getById = (id) => {
  const params = {
    Category:id,
  };

  return axiosGet(appsettings.ocpbComplaintAPIUrl + "api/EditorDom/GetById", params);
};

const updateItem = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/EditorDom/Update?userId=" +
      userData.userId(),
    params
  );
};


export {
  search,
  getById,
  updateItem,
};
